function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { styled, createTheme } from "../styles";
import Typography from "../Typography";
import Tooltip from "../Tooltip";
const theme = createTheme();
const Main = styled("div")(() => ({
  minWidth: "100px",
  overflow: "hidden",
  textOverflow: "inherit",
  whiteSpace: "nowrap"
}));
const Content = {
  overflow: "hidden",
  flex: 1,
  justifyContent: "flex-start"
};
const Label = {
  justifyContent: "flex-start",
  flex: 1,
  overflow: "hidden",
  textOverflow: "ellipsis"
};
const Info = {
  float: "right",
  marginLeft: "24px"
};
const LabelValueVertical = _ref => {
  let {
    label,
    infoText,
    ellipsisContent = true,
    labelStyle,
    contentStyle,
    showTooltip = true,
    paperBackground = false,
    children,
    ...restProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Main, restProps, infoText && /*#__PURE__*/React.createElement(Typography, _extends({
    component: "div",
    variant: "body2",
    sx: Info,
    textOverflow: ellipsisContent ? "ellipsis" : "initial"
  }, contentStyle), infoText), /*#__PURE__*/React.createElement(Typography, _extends({
    component: "div",
    sx: Label,
    variant: "overline",
    lineHeight: ellipsisContent ? theme.spacing(3) : theme.spacing(4)
  }, labelStyle), label), /*#__PURE__*/React.createElement(Tooltip, {
    title: showTooltip ? children : "",
    placement: "top-start"
  }, /*#__PURE__*/React.createElement(Typography, _extends({
    component: "div",
    variant: "body1",
    sx: Content,
    textOverflow: ellipsisContent ? "ellipsis" : "initial",
    whiteSpace: ellipsisContent ? "nowrap" : "initial",
    lineHeight: ellipsisContent ? theme.spacing(4) : "inherit"
  }, contentStyle), paperBackground == true ? /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: "#f5f5f5",
      padding: "5px",
      borderRadius: "5px"
    }
  }, children) : children)));
};
export default LabelValueVertical;